import router from '@/router'
import { GroupService } from '@/services/group.service'
import { CustomerGroupService } from '@/services/customer-group.service'
import { splitGroupsByParent, showErrorToast, commitPaginationFromMeta } from './helpers'

export const groupActions = {
  async loadGroupById({ commit }, id) {
    try {
      const response = await GroupService.group(id)
      commit('SET_GROUP', response.data.data)
    } catch (err) {
      showErrorToast(err)
      return err
    }
  },

  async loadCustomerGroupById({ commit }, id) {
    try {
      const response = await CustomerGroupService.get(id)
      commit('SET_CUSTOMER_GROUP', response.data.data)
    } catch (err) {
      showErrorToast(err)
      return err
    }
  },

  async loadParentAttributes({ commit }, id) {
    try {
      commit('SET_PARENT_ATTRIBUTE_PENDING', true)
      commit('SET_PARENT_ATTRIBUTES', [])
      const response = await GroupService.parentAttributes(id)
      commit('SET_PARENT_ATTRIBUTES', response.data)
      commit('SET_PARENT_ATTRIBUTE_PENDING', false)
    } catch (err) {
      showErrorToast(err)
      return err
    }
  },

  async loadGroups({ commit }, page) {
    try {
      const response = await GroupService.groups(page)
      const data = response.data.data

      if (page) {
        commit('SET_GROUPS', Array.isArray(data) ? data : [])
        commitPaginationFromMeta(commit, response)
        return
      }

      const { parents, children } = splitGroupsByParent(data)
      commit('SET_GROUPS', children)
      commit('SET_PARENT_GROUPS', parents)
    } catch (err) {
      showErrorToast(err)
      return err
    }
  },

  async loadParentGroupsIfNeeded({ commit, state }) {
    if (state.parentGroups?.length) {
      return
    }

    try {
      const response = await GroupService.groups()
      const { parents } = splitGroupsByParent(response.data.data)
      commit('SET_PARENT_GROUPS', parents)
    } catch (err) {
      showErrorToast(err)
      return err
    }
  },

  async loadCustomerGroups({ commit }) {
    try {
      const response = await CustomerGroupService.list()
      const data = response.data.data
      commit('SET_CUSTOMER_GROUPS', data)
    } catch (err) {
      showErrorToast(err)
      return err
    }
  },

  async storeGroup({ commit }, data) {
    try {
      const response = await GroupService.storeGroup(data)

      if (response) {
        router.push({ name: 'groups_list' })
      }
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  async storeCustomerGroup({ commit }, data) {
    try {
      const response = await CustomerGroupService.create(data)

      if (response) {
        router.push({ name: 'customer-groups-list' })
      }
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  async saveGroup(_, data) {
    try {
      return await GroupService.saveGroup(data, data.id)
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  async saveCustomerGroup({ commit }, data) {
    try {
      const response = await CustomerGroupService.update(data, data.id)

      if (response) {
        router.push({ name: 'customer-groups-list' })
      }
    } catch (e) {
      showErrorToast(e)
      return e
    }
  },

  selectChildrenGroups({ state }, id) {
    const groups = state.groups

    const filtered = groups.filter((item) => {
      if (item.parent_id == id) return item
    })

    const mapped = filtered.map((group) => {
      return group.id
    })

    return mapped
  }
}
